'use strict';

var DURATION_UNITS = require('./DURATION_UNITS');

module.exports = RegExp('(\\d+)?\\s*('+ DURATION_UNITS +')s?', 'i');


//////////////////
// WEBPACK FOOTER
// ./~/sugar/range/var/DURATION_REG.js
// module id = 872
// module chunks = 0